import { memo } from 'react';
import {
  CATEGORIES,
  CardsProps,
} from '@src/components/side-bar-menu/worlds/types';
import Card from './Card';
import styles from '../worlds-drawer.module.css';

export default memo(function Cards({
  items,
  onLoadWorld,
  selectedWorld,
  activeCategory,
}: CardsProps) {
  const isWorld = activeCategory === CATEGORIES.WORLDS;

  return (
    <div className={styles.worldsGrid}>
      {items?.map((item, i) => (
        <Card
          key={`${i}-${item.name}`}
          item={item}
          onLoadWorld={onLoadWorld}
          isSelected={
            selectedWorld === (isWorld ? item.baseModelURL : item.assetURL)
          }
          isWorld={isWorld}
        />
      ))}
    </div>
  );
});
